/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_With_HintInputs */



/**
* | output |
* | --- |
* | "That way Wundo knows where you left off at your next conversation, and you build a timeline you find back in your team overview." |
*
* @param {Manual_Meeting_With_HintInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_with_hint = /** @type {((inputs?: Manual_Meeting_With_HintInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_With_HintInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zo weet Wundo bij je volgende gesprek waar jullie gebleven waren, en bouw je een tijdlijn op die je terugvindt in je teamoverzicht.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ainsi, Wundo sait où vous en étiez lors de votre prochaine conversation, et vous construisez un fil que vous retrouvez dans votre aperçu d’équipe.")
	return /** @type {LocalizedString} */ ("That way Wundo knows where you left off at your next conversation, and you build a timeline you find back in your team overview.")
});